import { render, staticRenderFns } from "./Vue2LeafletHeatmap.vue?vue&type=template&id=9572b754&"
import script from "./Vue2LeafletHeatmap.vue?vue&type=script&lang=js&"
export * from "./Vue2LeafletHeatmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports